// extracted by mini-css-extract-plugin
export var banner = "_2x-0";
export var icon = "_2x-1";
export var message = "_2x-2";